import { render, staticRenderFns } from "./_Auth.vue?vue&type=template&id=6268874f&scoped=true&"
import script from "./_Auth.vue?vue&type=script&lang=js&"
export * from "./_Auth.vue?vue&type=script&lang=js&"
import style0 from "./_Auth.vue?vue&type=style&index=0&id=6268874f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268874f",
  null
  
)

export default component.exports